import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

import CustomerIdentityCustomerDetail from '../CustomerIdentity/CustomerDetail';
import CustomerIdentityCustomers from '../CustomerIdentity/CustomersAdmin';
import CustomerDataImport from '../CustomerIdentity/CustomerDataImport';
import LearnedAssociations from '../CustomerIdentity/LearnedAssociations';
import CustomerIdentityUsers from '../CustomerIdentity/CustomerIdentityUsers';
import ShipToAddressesDirectory from '../CustomerIdentity/ShipToAddressesDirectory';
import ContactsDirectory from '../CustomerIdentity/ContactsDirectory';
import CustomerIdentityUserGroups from '../CustomerIdentity/CustomerIdentityUserGroups';
import CustomerIdentityPlatformUsers from '../CustomerIdentity/PlatformUsers';
import CustomerIdentitySettings from '../CustomerIdentity/Settings';
import CustomerIdentitySiteDetail from '../CustomerIdentity/SiteDetail';
import CustomerIdentitySites from '../CustomerIdentity/Sites';

import { CiAdminAuthProvider } from '../../contexts/CiAdminAuthContext';
import CiAdminLayout, { CiAdminSuperAdminRoute } from './Layout';
import CiAdminLogin from './Login';

/**
 * Self-contained Customer Identity admin app, mounted at /cia/*.
 *
 * - Has its own auth context (platform JWT) — independent from the main app
 *   sidebar/Auth.
 * - The login screen is rendered without the layout chrome; everything else
 *   sits behind <CiAdminLayout> which gates on `isAuthenticated`.
 */
export default function CiAdminApp() {
  return (
    <CiAdminAuthProvider mode="platform">
      <Routes>
        <Route path="login" element={<CiAdminLogin />} />
        <Route element={<CiAdminLayout />}>
          <Route index element={<Navigate to="sites" replace />} />
          <Route path="sites" element={<CustomerIdentitySites />} />
          <Route path="sites/:siteId" element={<CustomerIdentitySiteDetail />} />
          <Route path="customers" element={<CustomerIdentityCustomers />} />
          <Route
            path="customers/:customerId"
            element={<CustomerIdentityCustomerDetail />}
          />
          <Route path="users" element={<CustomerIdentityUsers />} />
          <Route path="shipto-addresses" element={<ShipToAddressesDirectory />} />
          <Route path="contacts" element={<ContactsDirectory />} />
          <Route path="user-groups" element={<CustomerIdentityUserGroups />} />
          <Route path="settings" element={<CustomerIdentitySettings />} />
          <Route
            path="platform-users"
            element={(
              <CiAdminSuperAdminRoute>
                <CustomerIdentityPlatformUsers />
              </CiAdminSuperAdminRoute>
            )}
          />
          <Route
            path="customer-import"
            element={(
              <CiAdminSuperAdminRoute>
                <CustomerDataImport />
              </CiAdminSuperAdminRoute>
            )}
          />
          <Route
            path="learned-associations"
            element={(
              <CiAdminSuperAdminRoute>
                <LearnedAssociations />
              </CiAdminSuperAdminRoute>
            )}
          />
          <Route path="*" element={<Navigate to="sites" replace />} />
        </Route>
      </Routes>
    </CiAdminAuthProvider>
  );
}
